import React, { FC, useCallback, useMemo } from 'react'
import { getLineTournamentLink } from 'astra-core'
import { eventsProviderActions } from 'astra-core/containers/EventsProvider/slice'

import {
  useIsTopTournament,
  useLineTournamentEventsCount
} from 'entities/tournaments'
import { useAppDispatch } from 'store'
import { LINE_EVENTS_LIST_KEY } from 'pages/line-events-V2/model/constants'

import { LineTournamentProps } from './LineTournament.types'
import {
  StyledTournament,
  StyledTournamentAdditional,
  StyledTournamentText,
  StyledTournamentTop
} from './LineTournament.styled'
import { LineTournamentSport } from './LineTournamentSport'

export const LineTournament: FC<LineTournamentProps> = ({
  tournament,
  showSport,
  testData
}) => {
  const dispatch = useAppDispatch()

  const tournamentLink = useMemo(
    () => getLineTournamentLink(tournament),
    [tournament]
  )

  const handleClick = useCallback(() => {
    dispatch(
      eventsProviderActions.removeEventListInfo({
        listKey: LINE_EVENTS_LIST_KEY
      })
    )
  }, [dispatch])

  const isTopTournament = useIsTopTournament(tournament)
  const eventsCount = useLineTournamentEventsCount(tournament)

  return (
    <StyledTournament onClick={handleClick}>
      <StyledTournamentText data-test-id={testData} to={tournamentLink}>
        {isTopTournament && <StyledTournamentTop>TOP</StyledTournamentTop>}
        {!!showSport && <LineTournamentSport tournament={tournament} />}
        {tournament.name}

        <StyledTournamentAdditional>
          {eventsCount ?? ''}
        </StyledTournamentAdditional>
      </StyledTournamentText>
    </StyledTournament>
  )
}
